import Phrase from 'libs/translationsUtils/phrase'

const ContentType = ({ contentType, hasAnswer, articleLabel }) => {
  switch (contentType) {
    case 'discussion':
      return <Phrase p='topic.form.type.discussion.label' />
    case 'question':
      return !hasAnswer ? <Phrase p='content_type.label.question' /> : (
        <span><i class='icon icon--auto-width icon--thread-solved' /><Phrase p='answered.mark.title' /></span>)
    case 'article':
      return articleLabel || <Phrase p='content_type.label.article' />
    case 'ideation':
      return <Phrase m='Common' p='content_type.label.idea' />
  }
  return null
}

export default ContentType
